"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mixpanel_browser_1 = __importDefault(require("mixpanel-browser"));
const client_sdk_common_1 = require("@easygenerator/client-sdk.common");
const DISABLE_MIXPANEL_SESSION_RECORDING_FEATURE_FLAG = 'disable-mixpanel-session-record';
class MixpanelUtils {
    constructor(initData) {
        this.mixpanelInstance = mixpanel_browser_1.default;
        this.projectName = initData.projectName;
        this.projectId = initData.projectId;
        this.isSessionRecordDisabledByFeatureFlag = client_sdk_common_1.FeatureFlagsProvider.featureFlags.isFeatureEnabled(DISABLE_MIXPANEL_SESSION_RECORDING_FEATURE_FLAG);
        this.isSessionRecordingDisabledByInitData = initData.isSessionRecordingDisabled || false;
        client_sdk_common_1.FeatureFlagsProvider.featureFlags.on('update', this.updateValueOfIsMixpanelDisabled.bind(this));
    }
    get isMixpanelEnabled() {
        if (this.isSessionRecordingDisabledByInitData) {
            return false;
        }
        return this.mixpanelInstance[this.projectName] && !this.isSessionRecordDisabledByFeatureFlag;
    }
    on() {
        this.initMixplanel();
    }
    off() {
        this.stopSessionRecording();
        client_sdk_common_1.FeatureFlagsProvider.featureFlags.off('update', this.updateValueOfIsMixpanelDisabled.bind(this));
    }
    startSessionRecording() {
        var _a;
        (_a = this.mixpanelInstance[this.projectName]) === null || _a === void 0 ? void 0 : _a.start_session_recording();
    }
    stopSessionRecording() {
        var _a;
        (_a = this.mixpanelInstance[this.projectName]) === null || _a === void 0 ? void 0 : _a.stop_session_recording();
    }
    addSegmentMiddleware() {
        if (!this.isMixpanelEnabled) {
            return;
        }
        if (!window.analytics || !window.analytics.addSourceMiddleware) {
            return;
        }
        window.analytics.addSourceMiddleware(({ payload, next }) => {
            var _a;
            try {
                if (payload.obj.type === 'track' || payload.obj.type === 'page') {
                    const sessionReplayProperties = this.getSessionReplayProps(payload.obj.anonymousId);
                    payload.obj.properties = {
                        ...payload.obj.properties,
                        ...sessionReplayProperties
                    };
                }
                if (payload.obj.type === 'identify') {
                    (_a = this.mixpanelInstance[this.projectName]) === null || _a === void 0 ? void 0 : _a.identify(payload.obj.userId);
                }
                next(payload);
            }
            catch (error) {
                console.error('Error in Mixpanel Segment Middleware:', error);
                next(payload);
            }
        });
    }
    getSessionReplayProps(anonymousId) {
        var _a, _b;
        (_a = (this.mixpanelInstance)[this.projectName]) === null || _a === void 0 ? void 0 : _a.register({
            $device_id: anonymousId,
            distinct_id: anonymousId
        });
        return ((_b = this.mixpanelInstance[this.projectName]) === null || _b === void 0 ? void 0 : _b.get_session_recording_properties()) || {};
    }
    initMixplanel() {
        if (!this.isValidMixpanelConfig()) {
            console.warn('Mixpanel Project ID / Project name is not configured');
            return;
        }
        if (this.isSessionRecordDisabledByFeatureFlag) {
            console.warn('Mixpanel session recording is disabled due to feature flag.');
            return;
        }
        if (this.isSessionRecordingDisabledByInitData) {
            console.warn('Mixpanel session recording is disabled due to init configuration.');
            return;
        }
        if (this.mixpanelInstance[this.projectName]) {
            return;
        }
        this.mixpanelInstance.init(this.projectId, {
            autocapture: false,
            record_sessions_percent: 5,
            persistence: 'localStorage',
            ignore_dnt: true,
            record_idle_timeout_ms: 300000,
            record_block_selector: '[data-grammarly-shadow-root]'
        }, this.projectName);
    }
    isValidMixpanelConfig() {
        return Boolean(this.projectName && this.projectId);
    }
    updateValueOfIsMixpanelDisabled() {
        this.isSessionRecordDisabledByFeatureFlag = client_sdk_common_1.FeatureFlagsProvider.featureFlags.isFeatureEnabled(DISABLE_MIXPANEL_SESSION_RECORDING_FEATURE_FLAG);
        if (this.isSessionRecordDisabledByFeatureFlag && this.mixpanelInstance[this.projectName]) {
            this.mixpanelInstance[this.projectName].stop_session_recording();
            return;
        }
        if (!this.isSessionRecordDisabledByFeatureFlag && !this.mixpanelInstance[this.projectName]) {
            this.initMixplanel();
            this.addSegmentMiddleware();
        }
    }
}
exports.default = MixpanelUtils;
